import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  activeSwitch: {
    marginLeft: 'auto',
  },
}));

export default useStyles;
